export default __webpack_public_path__ + "static/media/Snd4.2aae7e6b.mp3";